import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { UrlConfig } from '../../../config/url.config';
import { Observable, of, throwError } from 'rxjs';
import { ValidationMessage } from '../../../../shared/constants/constant';
import { catchError, finalize, map, takeUntil } from 'rxjs/operators';
import { ErrorDialogService } from '../error/error-dialog.service';
import { LoaderService } from '../../loader/loader.service';
import { LoggingService } from './../../logging/logging.service';
import { ApplicationInsightsService } from '../../application-insights/application-insights.service';
import { HttpCancelService } from './../http-cancel.service';
import { Router, NavigationStart } from '@angular/router';
import { Constants } from './../../../../shared/constants/constant';
import { HttpCacheService } from '../httpCache.service';

@Injectable()
export class HttpCallInterceptor implements HttpInterceptor {

    constructor(private router: Router, public _errorDialogService: ErrorDialogService,
        public _loaderService: LoaderService, private _httpCancelService: HttpCancelService,
        private _applicationInsightsService: ApplicationInsightsService,
        public _loggingService: LoggingService,
        private _httpCacheService: HttpCacheService,) {

        this.router.events.subscribe(event => {
            // An event triggered at the start of the navigation part of the Resolve phase of routing.
            if (event instanceof NavigationStart) {
                // Cancel pending calls
                if (router.url != Constants.backSlash)
                    this._httpCancelService.cancelPendingRequests();
            }
        });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let cachedResponse;
		if (request.method === 'GET' || request.method === 'POST') {
			cachedResponse = this._httpCacheService.get(request);
			if (cachedResponse) {
                return of(cachedResponse);
			}
		}

        const requestBeginTime = performance.now();
        return next.handle(request).pipe(
            takeUntil(this._httpCancelService.onCancelPendingRequests()),                   
            map((httpEvent: HttpEvent<any>) => {
                if (httpEvent instanceof HttpResponse) {
                    this._httpCacheService.put(request, httpEvent);
                }
                return httpEvent;
            }),
            catchError((error: HttpErrorResponse) => {
                this._loaderService.displayNextClickSpinner = false;
                this._loaderService.displayLoaderAt = [];
                let errorMessage: any, errorStatusCode: any;
                if (error.status === 401) {
                    this._errorDialogService.openDialog(ValidationMessage.AccessDeniedError);
                    setTimeout(() => {
                        window.location.href = UrlConfig.nhwsUrl;
                    }, 3000);
                    return throwError(
                        "Unauthorized access denied or user session expired. You'll be redirected back to NHWS in few seconds."
                    );
                } else if (error.error instanceof ErrorEvent) {
                    // A client-side or network error occurred. Handle it accordingly.
                    errorMessage = error.error.message;
                } else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong,
                    errorMessage =
                        `Backend returned code ${error.status}, ` +
                        `body was: ${error.message}`;
                }
                errorStatusCode = error.status;

                let data = {};
                data = {
                    reason: error && error.error && error.error.reason ? error.error.reason : '',
                    status: error.status
                };
                this._applicationInsightsService.logError(errorMessage);

                this._errorDialogService.openDialog(ValidationMessage.ServerError);
                return throwError(errorMessage);
            }),
            finalize(() => {
                this._loggingService.logRequestTime(requestBeginTime, request);
            })
        );
    }
}
